import React, { Component } from 'react'
import styled from 'styled-components'
import { IconButton, Switch, Spinner } from 'react-mdl'
import Button from '../../components/Button'

import ScrollingDialog from '../../components/ScrollingDialog'
import MappingSelector from './MappingSelector'

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5em;
  width: 100%;
`
class MappingDialog extends Component {
  state = {
    showAll: this.props.showAllMapping || false,
    savePending: false,
  }

  toggleShowAll = () => this.setState(({ showAll }) => ({ showAll: !showAll }))
  handleChangeMapping = (...args) => {
    this.setState({ savePending: true })
    this.props.onChangeMapping(...args)
  }
  handleSaveMapping = (...args) => {
    this.setState({ savePending: false })
    this.props.saveMapping(...args)
  }

  render() {
    const {
      title,
      goBack,
      mapping,
      displaySpinner,
      showToggle = true,
      mappingWhitelist,
    } = this.props
    const { savePending, showAll } = this.state
    return (
      <ScrollingDialog
        title={title}
        actions={
          <ActionContainer>
            {showToggle
              ? <Switch checked={showAll} onChange={this.toggleShowAll}>
                  Show all Unit Elements
                </Switch>
              : <span />}
            {displaySpinner
              ? <Spinner />
              : <Button
                  disabled={!savePending}
                  raised
                  primary
                  onClick={this.handleSaveMapping}>
                  Save
                </Button>}
          </ActionContainer>
        }>
        <IconButton
          style={{ position: 'absolute', top: 0, right: 0 }}
          name="close"
          onClick={goBack}
        />
        <MappingSelector
          mapping={mapping}
          mappingWhitelist={mappingWhitelist}
          onChangeMapping={this.handleChangeMapping}
          showAll={showAll}
        />
      </ScrollingDialog>
    )
  }
}

export default MappingDialog



// WEBPACK FOOTER //
// ./src/Units/components/MappingDialog.js